export default __webpack_public_path__ + "static/media/SC-GN01-1.710c1ecc.jpg";